import { render, staticRenderFns } from "./PrijavaPitanja.vue?vue&type=template&id=95a06152&scoped=true&"
import script from "./PrijavaPitanja.vue?vue&type=script&lang=js&"
export * from "./PrijavaPitanja.vue?vue&type=script&lang=js&"
import style0 from "./PrijavaPitanja.vue?vue&type=style&index=0&id=95a06152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a06152",
  null
  
)

export default component.exports